import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Dashboard, ReactLoading } from "../Dashboard/TinManagement/import";
import {
  Button,
  Card,
  Drawer,
  Input,
  message,
  Modal,
  Select,
  Switch,
  Table,
} from "antd";
import {
  LockOutlined,
  MailOutlined,
  PlusOutlined,
  SaveOutlined,
  SearchOutlined,
  UserOutlined,
} from "@ant-design/icons";
import useAxios from "../../hooks/useAxios";
import { getAllUsers } from "../../services/users/users.service";
import saveLog from "../../services/saveLog";
import url from "../../services/url";
import $ from "jquery";
import isConsultant from "../../services/isConsultant";
import axios from "../../services/axios";
// import { Switch } from "antd";
import useRole from "../../hooks/useRole";
import { checkPermission } from "../../utils/checkPermission";
import NotAuthorized from "../../alert_pages/NotAuthorized";
// import saveLog from "../../services/saveLog";

const inputStyles = {
  padding: "10px 11px",
  fontSize: "16px",
  lineHeight: 1.5,
  borderRadius: "8px",
};

const emailRegex = /^(?!\.)(?!.*\.\.)[^\s@]+(?<!\.)@[^\s@]+\.[^\s@]+$/;

const Users = () => {
  const [openUserModal, setOpenUserModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const api = useAxios();

  const [rows, setRows] = useState([]);
  const [roles, setRoles] = useState([]);

  const toggleUserModal = () => setOpenUserModal(!openUserModal);

  const columns = [
    {
      title: "NAME",
      dataIndex: "name",
      key: "name",
      render: (value) => {
        return <span className="capitalize">{value}</span>;
      },
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "ROLE",
      dataIndex: "role",
      key: "role",
      render: (value) => {
        const isInterviewer =
          value?.toLowerCase() === "interviewer";
        const displayValue = isInterviewer ? "DH_Recruiters" : value;
        return <span className="capitalize">{displayValue}</span>;
      },
    },
    // {
    //   title: "STATUS",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (value, row) => {
    //     const label = value ? "Active" : "Inactive";
    //     const className = value
    //       ? "px-3 py-1 rounded-md text-sm font-semibold uppercase tracking-wide bg-green-100 text-green-700"
    //       : "px-3 py-1 rounded-md text-sm font-semibold uppercase tracking-wide bg-red-100 text-red-500 border border-red-300";
    //     return <span className={className}>{label}</span>;
    //   },
    // },
    {
      title: "USER ROLE & STATUS",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      render: (action, row) => {
        const { _id, value, status } = action;
        const isSelf = _id === localStorage.getItem("user.id");
        return (
          <div className="w-full flex gap-1">
            <Select
              className="!w-[170px] p-0 bg-white"
              showSearch
              optionFilterProp="children"
              disabled={!canChangeRole || isSelf}
              filterOption={(input, option) => {
                return (
                  String(option?.children ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase()) ||
                  String(option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                );
              }}
              placeholder="e.g. Interviewer"
              value={value ?? null}
              onChange={(value) => {
                onChangeRole(value, _id);
              }}
            >
              {roles
                .filter((role) => role.roleName?.toLowerCase() !== "dev_admin")
                .map((role) => {
                  const isInterviewer =
                    role.roleName?.toLowerCase() === "interviewer";

                  const roleDisplayName = isInterviewer
                    ? "DH_Recruiters"
                    : role.Name || role.roleName;
                  return (
                    <Select.Option key={role._id} value={role.roleName}>
                      {roleDisplayName}
                    </Select.Option>
                  );
                })}
            </Select>
            <Switch
              className="custom-orange-switch"
              disabled={!canChangeStatus || isSelf}
              onChange={() => onChangeUserStatus(_id)}
              checkedChildren={"ACTIVE"}
              unCheckedChildren={"INACTIVE"}
              checked={status}
            />
          </div>
        );
      },
    },
  ];

  const history = useHistory();

  const showRuleEngineModal = (ruleId) => {
    Modal.confirm({
      title: "User Mapped in Rule Engine",
      content:
        "This user is assigned to rules in Rule Engine. Please modify or remove their rules in Rule Engine first before changing their role.",
      okText: "Go to Rule Engine",
      cancelText: "Cancel",
      okButtonProps: { style: { backgroundColor: "#f27f21", borderColor: "#f27f21" } },
      onOk() {
        if (ruleId) {
          history.push(`/rule-engine/edit/${ruleId}`, { fromUsers: true });
        } else {
          history.push("/rule-engine", { fromUsers: true });
        }
      },
      onCancel() { },
    });
  };

  const onChangeRole = async (role, id) => {
    const targetUserRow = rows.find((r) => r.action?._id === id);
    const currentRole = targetUserRow?.role;

    if (currentRole?.toLowerCase() === "interviewer" && role?.toLowerCase() !== "interviewer") {
      try {
        setLoading(true);
        const { data: rules } = await api.get(`/ruleEngine/recruiter/${id}`, {
          tokenType: "user",
        });
        if (Array.isArray(rules) && rules.length > 0) {
          setLoading(false);
          const targetRuleId = rules[0]?._id || rules[0]?.id || rules[0]?.ruleId;
          showRuleEngineModal(targetRuleId);
          return;
        }
      } catch (err) {
        console.error("Error checking Rule Engine assignments:", err);
      } finally {
        setLoading(false);
      }
    }

    try {
      setLoading(true);
      await api.patch(`/user/${id}/role/${role}`, {}, { tokenType: "user" });
      await getUsers();
      message.success("User role updated successfully.");
    } catch (err) {
      console.error(err);
      if (err?.response?.data?.isRuleEngineMapped) {
        showRuleEngineModal();
      } else {
        message.error(err?.response?.data?.error || "Failed to update user role.");
      }
    } finally {
      setLoading(false);
    }
  };

  const onChangeUserStatus = async (id) => {
    try {
      setLoading(true);
      await api.put(
        `/user/InActivateCandidate/${id}`,
        {},
        { tokenType: "user" },
      );
      await getUsers();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const checkValidation = () => {
    let e = {};
    const name = userData?.name?.trim();
    const email = userData?.email?.trim();
    const password = userData?.password?.trim();

    if (!name) {
      e.name = "Name is required.";
    }

    if (!email) {
      e.email = "Email is required.";
    }

    if (!password) {
      e.password = "Password is required.";
    }

    if (email && !emailRegex.test(email)) {
      e.email = "Enter a valid email address.";
    }

    setError(e);

    return Object.keys(e).length === 0;
  };

  const saveUser = async () => {
    const isProceed = checkValidation();

    if (!isProceed) return;

    try {
      setLoading(true);
      const name = userData?.name?.trim();
      const email = userData?.email?.trim();
      const password = userData?.password?.trim();
      await api.post(
        `/user/register`,
        { name, email, password },
        { tokenType: "user" },
      );
      await getUsers();
      handleClose();
      message.success(`User Registered Successfully.`);
    } catch (err) {
      console.error(err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const getUsers = async () => {
    try {
      const { data } = await getAllUsers(api, "user");
      const _rows = [];
      for (let row of data) {
        _rows.push({
          role: row?.role,
          name: row?.name,
          //   status: row?.IsUserActive,
          searchRole: row?.role,
          searchName: row?.name,
          email: row?.email,
          action: {
            _id: row?._id,
            value: row?.role,
            status: row?.IsUserActive,
          },
          data: row,
        });
      }
      setRows(_rows);
    } catch (err) {
      console.error(err);
    }
  };

  const getRoles = async () => {
    try {
      const { data } = await api.get(`/role`, { tokenType: "user" });
      const filteredRoles = (data?.roleMaster || []).filter(
        (role) => role.roleName?.toLowerCase() !== "dev_admin"
      );
      setRoles(filteredRoles);
    } catch (err) {
      console.error("Failed to fetch roles:", err);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true);
        await Promise.all([getUsers(), getRoles()]);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    init();
  }, []);

  const filteredRows = rows.filter((row) => {
    const _search = search.toLowerCase();
    const isInterviewer =
      row.searchRole?.toLowerCase() === "interviewer" ||
      row.searchRole?.toLowerCase() === "interview";
    const displayRole = isInterviewer ? "DH_Recruiters" : row.searchRole;

    return (
      row.searchName.toLowerCase().includes(_search) ||
      row.email.toLowerCase().includes(_search) ||
      row.searchRole.toLowerCase().includes(_search) ||
      (displayRole && displayRole.toLowerCase().includes(_search))
    );
  });

  const handleInputChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  const handleClose = () => {
    toggleUserModal();
    setUserData(null);
  };


  const [canChangeRole, setCanChangeRole] = useState(false);
  const [canChangeStatus, setCanChangeStatus] = useState(false);
  const [canViewUsers, setCanViewUsers] = useState(false);
  const [canRegisterUser, setCanRegisterUser] = useState(false);
  const userRole = useRole();

  const checkManageUsersPermissions = async () => {
    try {
      const [roleAllowed, statusAllowed, viewAllowed, registerAllowed] =
        await Promise.all([
          checkPermission(userRole, "manage_users_module", "change_role"),
          checkPermission(userRole, "manage_users_module", "change_status"),
          checkPermission(userRole, "manage_users_module", "view_users"),
          checkPermission(userRole, "manage_users_module", "register_user"),
        ]);

      setCanChangeRole(roleAllowed);
      setCanChangeStatus(statusAllowed);
      setCanViewUsers(viewAllowed);
      setCanRegisterUser(registerAllowed);
    } catch (error) {
      console.error("Permission check failed for Manage Users Module:", error);
      setCanChangeRole(false);
      setCanChangeStatus(false);
      setCanViewUsers(false);
      setCanRegisterUser(false);
    }
  };

  useEffect(() => {
    checkManageUsersPermissions();
  }, [userRole]);

  if (!canViewUsers) {
    return <div></div>;
  }

  return (
    <Dashboard title="User Management">
      {loading && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="py-1 px-1">
        <h4 className="text-[1.5rem] mb-0">Users - Manage Users</h4>
        <p className="text-[0.89rem]">
          View and manage user accounts in one place.
        </p>
      </div>
      <div>
        <Card>
          <div className="flex flex-col gap-[1.5rem]">
            <div className="flex justify-between">
              <div className="flex-grow">
                <Input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    borderRadius: "8px",
                    width: "100%",
                    maxWidth: "300px",
                  }}
                  size="large"
                  placeholder="Search by name, email and role..."
                  prefix={<SearchOutlined />}
                />
              </div>
              {canRegisterUser && (
                <button
                  onClick={toggleUserModal}
                  data-testid="add-new"
                  className="btn btn-primary flex gap-[10px] items-center"
                >
                  <PlusOutlined
                    style={{ fontSize: "1.1rem", fontWeight: 600 }}
                  />
                  <span className="flex items-center text-[16px] font-semibold">
                    Register User
                  </span>
                </button>
              )}
            </div>
            <div>
              <Table
                columns={columns}
                dataSource={filteredRows}
                pagination={{
                  total: filteredRows?.length,
                  pageSizeOptions: ["5", "10", "30"],
                  showSizeChanger: true,
                  //   current: 1,
                  //   onChange: () => {},
                }}
                showSorterTooltip={false}
                scroll={{ x: true }}
                style={{ whiteSpace: "pre" }}
                exportFileName="details"
                size="small"
              />
            </div>
          </div>
        </Card>
      </div>
      <Drawer
        title="Register New User"
        width={550}
        placement="right"
        zIndex={9}
        closeIcon={false}
        onClose={handleClose}
        open={openUserModal}
        extra={<Button onClick={handleClose}>X</Button>}
      >
        <div className="d-flex flex-column gap-3" style={{ height: "100%" }}>
          <div className="row" style={{ flex: 1 }}>
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <div className="w-100 d-flex flex-column gap-1">
                    <div className="row">
                      <div className="col-12 mb-4 mt-0">
                        <div className="mb-[24px]">
                          <Input
                            type="text"
                            onChange={handleInputChange}
                            value={userData?.name ?? null}
                            style={inputStyles}
                            name="name"
                            allowClear
                            prefix={
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 6,
                                }}
                              >
                                <span className="pr-1">
                                  <UserOutlined />
                                </span>
                              </span>
                            }
                            size="large"
                            placeholder={"e.g. John Doe"}
                            status={error?.name && error?.name ? "error" : ""}
                          />
                          {error?.name && (
                            <div className="text-[#ff4d4f]">{error?.name}</div>
                          )}
                        </div>
                        <div className="mb-[24px]">
                          <Input
                            type="text"
                            onChange={handleInputChange}
                            value={userData?.email ?? null}
                            style={inputStyles}
                            name="email"
                            allowClear
                            prefix={
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 6,
                                }}
                              >
                                <span className="pr-1">
                                  <MailOutlined />
                                </span>
                              </span>
                            }
                            size="large"
                            placeholder={"e.g example@gamil.com"}
                            status={error?.email && error?.email ? "error" : ""}
                          />
                          {error?.email && (
                            <div className="text-[#ff4d4f]">{error?.email}</div>
                          )}
                        </div>
                        <div className="mb-[24px]">
                          <Input.Password
                            style={inputStyles}
                            name="password"
                            onChange={handleInputChange}
                            value={userData?.password ?? null}
                            size="large"
                            prefix={
                              <span className="pr-1">
                                <LockOutlined />
                              </span>
                            }
                            placeholder={"Enter Password"}
                            status={
                              error?.password && error?.password ? "error" : ""
                            }
                          />
                          {error?.password && (
                            <div className="text-[#ff4d4f]">
                              {error?.password}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-12">
              <div className="pt-3 d-flex gap-1">
                <button
                  onClick={handleClose}
                  className="save-filter-btn text-black rounded px-4 py-2 flex-1 text-[16px] font-semibold"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    saveUser();
                  }}
                  className="btn btn-primary flex gap-[10px] items-center justify-center flex-1"
                >
                  <SaveOutlined
                    style={{ fontSize: "1.1rem", fontWeight: 600 }}
                  />
                  <span className="flex items-center text-[16px] font-semibold text-center">
                    Save User
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </Dashboard>
  );
};

export default Users;
